import React from 'react';

/**
 * HeaderRow renders the top title line of a block item.
 * Title displays on the left (bold, primary), rightMeta displays on the right (italicized).
 */
export const HeaderRow = ({ title, rightMeta, style = {} }) => {
  if (!title && !rightMeta) return null;
  return (
    <div 
      className="block-header-row" 
      style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'baseline', 
        marginBottom: '2px', 
        pageBreakInside: 'avoid', 
        breakInside: 'avoid',
        width: '100%',
        ...style 
      }}
    >
      {title && (
        <strong 
          style={{ 
            fontSize: 'var(--font-size-subheading, 9.5pt)', 
            color: 'var(--color-text-main, #2C3E50)',
            fontWeight: 'var(--weight-subheading, 700)'
          }}
        >
          {title}
        </strong>
      )}
      {rightMeta && (
        <span 
          style={{ 
            fontSize: 'var(--font-size-meta, 8pt)', 
            color: 'var(--color-text-light, #7F8C8D)', 
            fontStyle: 'italic',
            fontWeight: 'var(--weight-regular, 400)',
            whiteSpace: 'nowrap'
          }}
        >
          {rightMeta}
        </span>
      )}
    </div>
  );
};
export default HeaderRow;
